import { Grid } from '@material-ui/core'
import { useFormikContext } from 'formik'
import { useMemo } from 'react'

import { PureAsyncSearchInput } from 'src/components/Formik/Forms/PureAsyncSearchInput'

import { formatLabelPerson } from 'src/modules/pessoas/utils'
import { formatLabelEndereco } from 'src/modules/pessoas/utils/labelFormatEndereco'

import { LotesFormData } from '../../types'

interface Props {
  isRestrictedEdit: boolean
}

export const LocalColetaFields = ({ isRestrictedEdit }: Props) => {
  const { values } = useFormikContext<LotesFormData>()

  const enderecoLocalColetaFilters = useMemo(
    () => ({
      pessoaId: values.localColeta?.value
    }),
    [values.localColeta?.value]
  )

  return (
    <>
      <Grid item xs={12} sm={3}>
        <PureAsyncSearchInput
          name="localColeta"
          label="Local de Coleta (opcional)"
          url="/pessoas"
          filters={{ ativo: true }}
          labelFormat={formatLabelPerson}
          paramSearch="nomeDocumento"
          disabled={isRestrictedEdit}
          allowSearchWhenDisabled
        />
      </Grid>

      <Grid item xs={12} sm={3}>
        <PureAsyncSearchInput
          name="enderecoLocalColeta"
          label="Endereço Local de Coleta (opcional)"
          url="/enderecos"
          filters={enderecoLocalColetaFilters}
          labelFormat={formatLabelEndereco}
          paramSearch="logradouro"
          disabled={!values.localColeta?.value || isRestrictedEdit}
          allowSearchWhenDisabled
        />
      </Grid>
    </>
  )
}
